import { cn, getBackgroundClass, getBackgroundStyle } from '@workspace/lib';
import { imageTextBlockVariants, shouldUseLightText } from '@workspace/blocks/ImageTextBlock/imageTextBlock.variants';
import { CustomPortableText } from '@workspace/ui/PortableText';
import { Picture } from '@workspace/ui/common';

import type { ImageTextBlockProps } from './image-text-block.types';
import { ImageTextMedia } from './ImageTextMedia.ui';

export function ImageTextBlock({ block }: ImageTextBlockProps) {
  if (!block || typeof block !== 'object') return null;

  const {
    imagePosition = false,
    image,
    bynderIcon,
    iconPosition = 'left',
    body,
    backgroundColor,
    textImageBackgroundColor,
    isVideo = false,
    video,
  } = block;

  const selectedBackgroundColor = textImageBackgroundColor ?? backgroundColor;
  const backgroundClass = getBackgroundClass(selectedBackgroundColor);
  const backgroundStyle = backgroundClass ? undefined : getBackgroundStyle(selectedBackgroundColor);
  const hasLightText = shouldUseLightText({ backgroundClass });
  const {
    container,
    section,
    layout,
    textColumn,
    content,
    iconWrapper,
    body: bodyClass,
    mediaColumn,
    mediaFrame,
  } = imageTextBlockVariants({
    imagePosition,
    iconPosition,
    isVideo,
    hasLightText,
  });

  return (
    <div className={cn('image-text-block-bg w-full', container?.(), backgroundClass)} style={backgroundStyle}>
      <section className={cn('porta-container', section())}>
        <div className={layout()}>
          <div className={textColumn()}>
            <div className={content()}>
              {bynderIcon && (
                <div className={iconWrapper()}>
                  <Picture
                    image={bynderIcon}
                    alt={bynderIcon.alt || bynderIcon.name || ''}
                    desktopWidth={48}
                    desktopHeight={48}
                    className="block size-12"
                    imgClassName="size-12 object-contain"
                  />
                </div>
              )}
              {body?.length > 0 && <CustomPortableText value={body} className={bodyClass()} />}
            </div>
          </div>

          <div className={mediaColumn()}>
            <div className={mediaFrame()}>
              <ImageTextMedia isVideo={isVideo} video={video} image={image} />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
